import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  MenuItem,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import _, { debounce } from "lodash";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import SelectAutoComplete from "../../components/SelectAutoComplete";
import { mapActionsToProps as phoneNumberAction } from "../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps } from "../../redux/report/configureBillingTime";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  grid: {
    alignItems: "center",
    display: "flex",
    width: "100%",
  },
  input: {
    width: "100%",
  },
  disabled: {
    color: "#000000 !important",
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class ConfigureBillingTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          from: null,
          lte: null,
          nameTicket: "",
          contentTicket: "",
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      modalAction: false,
      loadingBtn: false,
      listAgents: [],
      selectedNumber: "",
      listPhoneNumber: [],
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListPhoneNumber();
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listAgents)) !==
        JSON.parse(JSON.stringify(_.values(props.listAgents))) &&
      !state.listAgents
    ) {
      return {
        listAgents: _.values(props.listAgents),
      };
    }
    if (
      JSON.parse(JSON.stringify(state.listPhoneNumber)) !==
        JSON.parse(JSON.stringify(_.values(props.listPhoneNumber))) &&
      !state.listPhoneNumber.length
    ) {
      return {
        listPhoneNumber: _.values(props.listPhoneNumber),
      };
    }
    return null;
  }

  listColumns = [
    { id: "number", numeric: true, disablePadding: false, label: "Đầu số" },
    {
      id: "inboundDuration",
      numeric: true,
      disablePadding: false,
      label: "Gọi vào",
    },
    {
      id: "outboundDuration",
      numeric: true,
      disablePadding: false,
      label: "Gọi ra",
    },
    {
      id: "actionPhoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Hành động",
    },
  ];

  itemInit() {
    const where = {};
    const and = [];

    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "createdAt":
            case "number":
            case "type":
            case "durationType":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push(
                    {
                      createdAt: {
                        gte: datetimeHelper.toFormat(
                          this.state.filters.where.from,
                          "YYYY-MM-DD startDay"
                        ),
                      },
                    },
                    {
                      createdAt: {
                        lte: datetimeHelper.toFormat(
                          this.state.filters.where.from,
                          "YYYY-MM-DD endDay"
                        ),
                      },
                    }
                  );
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListConfigureBillingTime(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
    this.props.countListConfigureBillingTime({ where: { ...where } });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.setState({ modalAction: true, item: item });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    if (this.state.selectedNumber) {
      filters.where["number"] = this.state.selectedNumber;
    } else {
      delete filters.where["number"];
    }
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChange = (name) => {
    const { filters } = this.state;
    return (e) => {
      filters.where[name] = e.target.value;
      return this.setState({
        filters,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      const value =
        e.target.value === "duration"
          ? "Thời gian kết nối"
          : "Thời gian trả lời";
      this.setState({
        item: {
          ...this.state.item,
          [name]: value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {} });
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  handleAction = () => {
    const item = this.state.item;
    if (!item) {
      const { number, inboundDuration, outboundDuration } = this.state;
      return (
        this.props.addConfig(number, inboundDuration, outboundDuration),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      let { number, inboundDuration, outboundDuration } = this.state.item;
      const convert = (type) => {
        if (type === "Thời gian kết nối") {
          return "duration";
        } else if (type === "Thời gian trả lời") {
          return "answerDuration";
        }
      };
      return (
        this.props.editConfig(
          number,
          convert(inboundDuration),
          convert(outboundDuration)
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteConfig(this.state.item.number);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleSearchNumber = (text) => {
    const { listPhoneNumber } = this.props;
    this.setState({
      listPhoneNumber: this.filterNumbers(_.values(listPhoneNumber), text),
    });
  };

  filterNumbers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.id &&
              item.id.toLowerCase().includes(search.toLowerCase())
          )
        : array;
    }
    return array;
  };

  render() {
    const { classes, campaignsGroup, listPhoneNumber, listItem } = this.props;
    const { id, number, outboundDuration, inboundDuration, filters, item } =
      this.state;
    const listResult =
      typeof listItem === "object"
        ? Object.keys(listItem).map((key) => listItem[key])
        : listItem;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={3}>
                        <SelectAutoComplete
                          label={"Đầu số"}
                          data={
                            this.state.listPhoneNumber &&
                            this.state.listPhoneNumber.length > 0
                              ? this.state.listPhoneNumber.map((val) => {
                                  return {
                                    id: val.id,
                                    label: val ? `${val.id}` : "",
                                  };
                                })
                              : []
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchNumber(text),
                            300
                          )}
                          onChange={(item) => {
                            this.setState({
                              selectedNumber: item ? item.id : "",
                            });
                          }}
                          onClear={true}
                          name="number"
                        />
                        {/*<SelectValidator*/}
                        {/*    id="outlined-full-width"*/}
                        {/*    margin="normal"*/}
                        {/*    label="Đầu số"*/}
                        {/*    variant="outlined"*/}
                        {/*    className={classes.input}*/}
                        {/*    onChange={this.handleChange('number')}*/}
                        {/*    value={filters.where.number}*/}
                        {/*    name="number"*/}
                        {/*    SelectProps={{*/}
                        {/*        MenuProps: {*/}
                        {/*            className: classes.menu,*/}
                        {/*            shrink: true,*/}
                        {/*        },*/}
                        {/*    }}*/}
                        {/*    InputLabelProps={{*/}
                        {/*        shrink: true,*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <MenuItem><em>Tất cả</em></MenuItem>*/}
                        {/*    {*/}
                        {/*        listPhoneNumberResult ? (*/}
                        {/*            listPhoneNumberResult.map((item, key) => {*/}
                        {/*                return (*/}
                        {/*                    <MenuItem key={key}*/}
                        {/*                              value={item.id}>{item.id}</MenuItem>*/}
                        {/*                )*/}
                        {/*            })*/}
                        {/*        ) : <React.Fragment/>*/}
                        {/*    }*/}
                        {/*</SelectValidator>*/}
                      </Grid>
                      {/*<Grid item md={3}>*/}
                      {/*    <SelectValidator*/}
                      {/*        id="outlined-full-width"*/}
                      {/*        margin="normal"*/}
                      {/*        select*/}
                      {/*        SelectProps={{*/}
                      {/*            MenuProps: {*/}
                      {/*                className: classes.menu,*/}
                      {/*                shrink: true,*/}
                      {/*            },*/}
                      {/*        }}*/}
                      {/*        InputLabelProps={{*/}
                      {/*            shrink: true,*/}
                      {/*        }}*/}
                      {/*        label="Phân loại"*/}
                      {/*        variant="outlined"*/}
                      {/*        className={classes.input}*/}
                      {/*        onChange={this.handleSearch}*/}
                      {/*        value={filters.where.type}*/}
                      {/*        name="type"*/}
                      {/*    >*/}
                      {/*        <MenuItem>*/}
                      {/*            Tất cả*/}
                      {/*        </MenuItem>*/}
                      {/*        <MenuItem key="inbound" value="inbound">*/}
                      {/*            Gọi vào*/}
                      {/*        </MenuItem>*/}
                      {/*        <MenuItem key="outbound" value="outbound">*/}
                      {/*            Gọi ra*/}
                      {/*        </MenuItem>*/}
                      {/*    </SelectValidator>*/}
                      {/*</Grid>*/}
                      {/*<Grid item md={3}>*/}
                      {/*    <SelectValidator*/}
                      {/*        id="outlined-full-width"*/}
                      {/*        margin="normal"*/}
                      {/*        select*/}
                      {/*        SelectProps={{*/}
                      {/*            MenuProps: {*/}
                      {/*                className: classes.menu,*/}
                      {/*                shrink: true,*/}
                      {/*            },*/}
                      {/*        }}*/}
                      {/*        InputLabelProps={{*/}
                      {/*            shrink: true,*/}
                      {/*        }}*/}
                      {/*        label="Loại thời gian tính tiền"*/}
                      {/*        variant="outlined"*/}
                      {/*        className={classes.input}*/}
                      {/*        onChange={this.handleSearch}*/}
                      {/*        value={filters.where.durationType}*/}
                      {/*        name="durationType"*/}
                      {/*    >*/}
                      {/*        <MenuItem>*/}
                      {/*            Tất cả*/}
                      {/*        </MenuItem>*/}
                      {/*        <MenuItem key="duration" value="duration">*/}
                      {/*            Thời gian kết nối*/}
                      {/*        </MenuItem>*/}
                      {/*        <MenuItem key="answerDuration" value="answerDuration">*/}
                      {/*            Thời gian trả lời*/}
                      {/*        </MenuItem>*/}
                      {/*    </SelectValidator>*/}
                      {/*</Grid>*/}
                      <Grid
                        item
                        md={3}
                        style={{ alignItem: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            type="submit">
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Cấu hình thời gian tính tiền theo đầu số"
          items={
            Array.isArray(listResult) && listResult.length > 0 ? listResult : []
          }
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listColumns}
          allowCreate={false}
          handleView={this.openModalView}
          handleEdit={this.openModalEdit}
          // handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          // createAction={
          //     <div style={ { display: 'flex' } }>
          //         <Tooltip title="Thêm mới" disableFocusListener style={ { marginLeft: 10 } }>
          //             <Fab
          //                 color="primary" aria-label="add"
          //                 className={ classes.fab }
          //                 size="small"
          //                 onClick={ this.handleCreateModel }
          //             >
          //                 <Add className={ classes.add }/>
          //             </Fab>
          //         </Tooltip>
          //     </div>
          // }
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item
              ? item.number
                ? "Chỉnh sửa cấu hình"
                : "Thêm mới cấu hình"
              : null
          }
          maxWidth={"md"}
          fullWidth={true}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <Grid item xs={12} style={{ padding: 5 }}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Đầu số"
                      variant="outlined"
                      className={classes.input}
                      disabled
                      // onChange={ !!item ? (item.number ? this.handleChangeTextEdit('number') : this.handleChangeText('number')) : null }
                      value={item ? (item.number ? item.number : number) : null}
                      name="number"
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                          shrink: true,
                        },
                      }}
                      // validators={["required"]}
                      // errorMessages={"Không được để trống"}
                      InputLabelProps={{
                        shrink: true,
                      }}>
                      {/*{*/}
                      {/*    listPhoneNumberResult ? (*/}
                      {/*        listPhoneNumberResult.map((item, key) => {*/}
                      {/*            return (*/}
                      {/*                <MenuItem key={key}*/}
                      {/*                          value={item.id}>{item.id}</MenuItem>*/}
                      {/*            )*/}
                      {/*        })*/}
                      {/*    ) : <React.Fragment/>*/}
                      {/*}*/}
                    </TextValidator>
                  </Grid>
                  <Grid item xs={12} style={{ padding: 5 }}>
                    <SelectValidator
                      id="outlined-full-width"
                      margin="normal"
                      select
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                          shrink: true,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Gọi vào"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? this.handleChangeTextEdit("inboundDuration")
                          : this.handleChangeText("inboundDuration")
                      }
                      value={
                        item
                          ? item.inboundDuration
                            ? item.inboundDuration === "Thời gian kết nối"
                              ? "duration"
                              : "answerDuration"
                            : inboundDuration
                          : null
                      }
                      name="inboundDuration">
                      <MenuItem key="duration" value="duration">
                        Thời gian kết nối
                      </MenuItem>
                      <MenuItem key="answerDuration" value="answerDuration">
                        Thời gian trả lời
                      </MenuItem>
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={12} style={{ padding: 5 }}>
                    <SelectValidator
                      id="outlined-full-width"
                      margin="normal"
                      select
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                          shrink: true,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Gọi ra"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? this.handleChangeTextEdit("outboundDuration")
                          : this.handleChangeText("outboundDuration")
                      }
                      value={
                        item
                          ? item.outboundDuration
                            ? item.outboundDuration === "Thời gian kết nối"
                              ? "duration"
                              : "answerDuration"
                            : outboundDuration
                          : null
                      }
                      name="outboundDuration">
                      <MenuItem key="duration" value="duration">
                        Thời gian kết nối
                      </MenuItem>
                      <MenuItem key="answerDuration" value="answerDuration">
                        Thời gian trả lời
                      </MenuItem>
                    </SelectValidator>
                  </Grid>
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modalDelete}
          title={`Bạn có muốn xóa cấu hình`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

ConfigureBillingTime.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.configureBillingTime.loading,
  count: state.configureBillingTime.count,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  listItem: state.configureBillingTime.items,
});

const NumberConnect = connect(null, phoneNumberAction)(ConfigureBillingTime);

ConfigureBillingTime = connect(
  mapStateToProps,
  mapActionsToProps
)(NumberConnect);

export default withStyles(styles)(ConfigureBillingTime);
